var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanningBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.4 19.4",
    style: {
      enableBackground: "new 0 0 19.4 19.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill: #004162;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,13h-1c-0.1-0.4-0.2-0.8-0.5-1.1l0.7-0.7c0.1-0.1,0.1-0.2,0-0.2l-1-1c-0.1-0.1-0.2-0.1-0.2,0l-0.7,0.7 c-0.3-0.2-0.7-0.4-1.1-0.5v-1c0-0.1-0.1-0.2-0.2-0.2h-0.1V4.4c0-2.1-3-3.7-6.8-3.7S0.8,2.3,0.8,4.4v5v5c0,2.1,2.9,3.7,6.8,3.7 c1.1,0,2.1-0.1,3.1-0.4l0.2,0.2c0,0,0.1,0,0.1,0s0.1,0,0.1,0l0.7-0.7c0.3,0.2,0.7,0.4,1.1,0.5v1c0,0.1,0.1,0.2,0.2,0.2h1.4 c0.1,0,0.2-0.1,0.2-0.2v-1c0.4-0.1,0.8-0.2,1.1-0.5l0.7,0.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l1-1c0.1-0.1,0.1-0.2,0-0.2L17,15.8 l0.5-1.1h1c0.1,0,0.2-0.1,0.2-0.2v-1.4C18.6,13.1,18.6,13,18.5,13z M7.6,1.9c3.3,0,5.6,1.3,5.6,2.5s-2.3,2.5-5.6,2.5S2,5.6,2,4.4 S4.3,1.9,7.6,1.9z M2,14.3v-2.8c1.2,0.9,3.2,1.5,5.6,1.5c0.5,0,0.9,0,1.3-0.1c0,0,0.7-0.1,1.3-0.3c0,0.1-0.1,0.2-0.1,0.3h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.4c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0.4,0.2,0.8,0.5,1.1l-0.7,0.7c-0.7,0.2-1.5,0.3-2.3,0.3 C4.3,16.8,2,15.5,2,14.3z M10.6,11.9L10.6,11.9L10.6,11.9C10.6,11.9,10.6,11.9,10.6,11.9z M10.8,10l-1,1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1l0.4,0.4c-0.8,0.2-1.7,0.3-2.6,0.3C4.3,11.8,2,10.5,2,9.4V6.6c1.2,0.9,3.2,1.6,5.6,1.6s4.4-0.6,5.6-1.6V9h-0.1 c-0.1,0-0.2,0.1-0.2,0.2v1c-0.4,0.1-0.8,0.2-1.1,0.5L11.1,10C11,9.9,10.9,9.9,10.8,10z M13.8,16.3c-1.4,0-2.5-1.1-2.5-2.5 s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S15.1,16.3,13.8,16.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningBlue);
export default __webpack_public_path__ + "static/media/planning_Blue.89aefb0fefa1e81ad7ac190b8a60238c.svg";
export { ForwardRef as ReactComponent };